import React, { Component } from "react";
import { Button } from "@material-ui/core";
import Moment from "react-moment";
import { GetWalletDetails } from "../../../../services";

export default class WalletTransactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: [],
      batch: 1,
      search: "",
      message: "",
      isloaded: false,
    };
  }

  async fetchTransactions() {
    this.setState({ isloaded: true, message: "" });

    const result = await GetWalletDetails.getWalletTransactions(
      this.state.batch,
      this.state.search
    );

    if (!result || result.success === false) {
      this.setState({
        transactions: [],
        message: result && result.message
          ? result.message
          : "No records found",
        isloaded: false,
      });
      return;
    }

    this.setState({
      transactions: result.transactions || [],
      isloaded: false,
    });
  }

  handleBatchChange = (dir) => {
    let newBatch = this.state.batch + dir;
    if (newBatch < 1) newBatch = 1;

    this.setState({ batch: newBatch }, () => {
      this.fetchTransactions();
      window.scrollTo(0, 0);
    });
  };

  componentDidMount() {
    this.fetchTransactions();
  }

  render() {
    const { transactions, batch, search, message } = this.state;

    return (
      <div className="container-fluid">
        <h2 className="mt-30 page-title">Wallet Transactions</h2>

        {/* 🔍 SEARCH */}
        <div style={{ marginBottom: 15 }}>
          <input
            type="text"
            placeholder="Search by Email or Phone"
            value={search}
            onChange={(e) => this.setState({ search: e.target.value })}
            style={{ marginRight: 10 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.fetchTransactions()}
          >
            Search
          </Button>
        </div>

        <div className="card card-static-2 mb-30">
          <div className="card-body-table">
            <div className="table-responsive">
              <table className="table ucp-table table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Date</th>
                    <th>Customer</th>
                    <th>Wallet Balance</th>
                    <th>Amount</th>
                    <th>Type</th>
                    <th>Source</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {message ? (
                    <tr>
                      <td colSpan="8" style={{ textAlign: "center", color: "red" }}>
                        {message}
                      </td>
                    </tr>
                  ) : transactions.length === 0 ? (
                    <tr>
                      <td colSpan="8">Loading...</td>
                    </tr>
                  ) : (
                    transactions.map((row, index) => (
                      <tr key={index}>
                        <td>{row.id}</td>
                        <td>
                          <Moment format="MMMM Do YYYY">
                            {row.createdAt}
                          </Moment>
                          <br />
                          <Moment format="h:mm:ss a">
                            {row.createdAt}
                          </Moment>
                        </td>
                        <td>
                          <div>
                            <strong>
                              {row.customer && row.customer.fullName
                                ? row.customer.fullName
                                : "N/A"}
                            </strong>
                          </div>
                          <div>
                            {row.customer && row.customer.email
                              ? row.customer.email
                              : "N/A"}
                          </div>
                          <div>
                            {row.customer && row.customer.phone
                              ? row.customer.phone
                              : "N/A"}
                          </div>
                        </td>
                        <td>
                          ₹{row.walletBalance}
                        </td>
                        <td>
                          ₹{row.amount}
                        </td>
                        <td>{row.type}</td>
                        <td>{row.source}</td>
                        <td>{row.status}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* PAGINATION */}
            <div className="pagination-buttons">
              <Button
                variant="contained"
                onClick={() => this.handleBatchChange(-1)}
                disabled={batch <= 1}
              >
                Previous Batch
              </Button>
              <Button
                variant="contained"
                onClick={() => this.handleBatchChange(1)}
                style={{ marginLeft: 10 }}
              >
                Next Batch
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/wallet/transactions/index.js